module.exports = __webpack_public_path__ + "/static/assets/94b06fb716871f81bec601724e29a457.svg";